import { compose } from 'ramda';
import { defaultProps } from 'recompose';

import SettingsPageHeader from '@/components/PageHeader';

export default compose(
  defaultProps({ borderBottom: false, gutterBottom: true, sm: 11 }),
)(SettingsPageHeader);
